import { ISbRichtext } from '@storyblok/react';
import React from 'react';

import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import { getStoryblokRichText } from '../../../../richtext/src/components/StoryblokRichtext/getStoryblokRichText';
import { getStoryblokRichTextAsPlainText } from '../../../../utils';
import type { SBAccordionItemProps } from './SBAccordionItem';

type FaqSchemaFromAccordionProps = {
  items?: SBAccordionItemProps[];
};

export const FaqSchemaFromAccordion = ({ items }: FaqSchemaFromAccordionProps) => {
  const validItems = items?.filter(item => item?.body && item?.title).filter(Boolean) || [];

  if (!isArrayWithLength(validItems)) return null;

  const faqItems = validItems.map(item => {
    const accordionItemRichtext = item?.body?.find(item => item.component === 'richtext');
    const richtext = getStoryblokRichText(accordionItemRichtext?.content as ISbRichtext);
    const text = getStoryblokRichTextAsPlainText(richtext);

    return {
      '@type': 'Question',
      name: item?.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: text,
      },
    };
  });

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
    />
  );
};
